/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InspectionResultResponse } from './InspectionResultResponse';
import {
    InspectionResultResponseFromJSON,
    InspectionResultResponseFromJSONTyped,
    InspectionResultResponseToJSON,
    InspectionResultResponseToJSONTyped,
} from './InspectionResultResponse';

/**
 * Paginated response containing inspection results
 * @export
 * @interface PagedResultsResponse
 */
export interface PagedResultsResponse {
    /**
     * List of inspection results
     */
    results?: Array<InspectionResultResponse>;
    /**
     * Current page number (0-based)
     */
    pageNumber?: number;
    /**
     * Number of results per page
     */
    perPage?: number;
    /**
     * Total number of results matching the query
     */
    totalResults?: number;
    /**
     * Total number of pages
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the PagedResultsResponse interface.
 */
export function instanceOfPagedResultsResponse(value: object): value is PagedResultsResponse {
    return true;
}

export function PagedResultsResponseFromJSON(json: any): PagedResultsResponse {
    return PagedResultsResponseFromJSONTyped(json, false);
}

export function PagedResultsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedResultsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(InspectionResultResponseFromJSON)),
        'pageNumber': json['pageNumber'] == null ? undefined : json['pageNumber'],
        'perPage': json['perPage'] == null ? undefined : json['perPage'],
        'totalResults': json['totalResults'] == null ? undefined : json['totalResults'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
    };
}

export function PagedResultsResponseToJSON(json: any): PagedResultsResponse {
    return PagedResultsResponseToJSONTyped(json, false);
}

export function PagedResultsResponseToJSONTyped(value?: PagedResultsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'results': value['results'] == null ? undefined : ((value['results'] as Array<any>).map(InspectionResultResponseToJSON)),
        'pageNumber': value['pageNumber'],
        'perPage': value['perPage'],
        'totalResults': value['totalResults'],
        'totalPages': value['totalPages'],
    };
}

